import { render, staticRenderFns } from "./section-dept.vue?vue&type=template&id=dc24bdae&"
import script from "./section-dept.vue?vue&type=script&lang=js&"
export * from "./section-dept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "section-dept.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/business/select-member/section/section-dept.vue
// module id = 182
// module chunks = 0